import React, { useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { AppIcon } from "components/AppIcon";

interface TopSummaryCardsProps {
  summaryData: any;  // or your exact type
  baseRoute?: string;
}

const TopSummaryCards: React.FC<TopSummaryCardsProps> = ({
  summaryData,
  baseRoute = "/signage",
}) => {
  const navigate = useNavigate();
  const data = summaryData || {};

  // 🔹 Memoize the cards array so it only recalculates when data changes
  const cards = useMemo(() => {
    return [
      {
        title: "Total Brokerages",
        value: Number(data?.total_brokerages || 0).toLocaleString(),
        icon: <AppIcon name="building" size={36} alt="Total Brokerages" />,
        href: `${baseRoute}/brokerageFirms`,
      },
      {
        title: "Total Agents",
        value: Number(data?.total_agents || 0).toLocaleString(),
        icon: <AppIcon name="team" size={36} alt="Total Agents" />,
        href: `${baseRoute}/agents`,
      },
      {
        title: "Warehouse Assets",
        value: Number(data?.warehouse_assets || 0).toLocaleString(),
        icon: <AppIcon name="warehouse" size={36} alt="Warehouse Assets" />,
        href: `${baseRoute}/warehouses`,
      },
      {
        title: "Office Inventory",
        value: Number(data?.office_inventory || 0).toLocaleString(),
        icon: <AppIcon name="officeInventory" size={36} alt="Office Inventory" />,
        href: `${baseRoute}/officeInventory`,
      },
      {
        title: "Agent Inventory",
        value: Number(data?.agent_inventory || 0).toLocaleString(),
        icon: <AppIcon name="agentInventory" size={36} alt="Agent Inventory" />,
        href: `${baseRoute}/agentInventory`,
      },
    ];
  }, [
    data?.total_brokerages,
    data?.total_agents,
    data?.warehouse_assets,
    data?.office_inventory,
    data?.agent_inventory,
    baseRoute,
  ]);

  return (
<div className="row g-3 mb-4">
  {cards.map((card, idx) => (
    <div
      key={idx}
      className="col-12 col-sm col-md col-lg d-flex"
      style={{ minWidth: "200px" }} // optional to maintain decent card width
    >
      <div
        role="link"
        tabIndex={0}
        onClick={() => navigate(card.href)}
        onKeyDown={(e) => {
          if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            navigate(card.href);
          }
        }}
        className="card shadow-border-1 box-shadow-datatables bg-white w-100 h-100 text-decoration-none text-reset dashboard-summary-card-link"
        style={{
          borderRadius: "12px",
          border: "1px solid #E5E7EB",
          cursor: "pointer",
        }}
      >
        <div className="card-body d-flex justify-content-between align-items-center">
          <div>
            <h6 className="font-medium text-gray-600 text-xs" style={{ fontSize: "0.9rem" }}>
              {card.title}
            </h6>
            <h4 className="fw-bold mb-0 text-dark">{card.value}</h4>
          </div>

          <div className="d-flex align-items-center justify-content-center">
            {card.icon}
          </div>
        </div>
      </div>
      <style>{`
        .card:hover {
          box-shadow: 0 3px 12px rgba(0,0,0,0.06) !important;
          transform: translateY(-1px);
          transition: 0.2s ease;
        }

        .dashboard-summary-card-link:hover {
          box-shadow: 0 3px 12px rgba(0, 0, 0, 0.08) !important;
          transform: translateY(-1px);
          transition: 0.2s ease;
        }
        .text-gray-600 {
          color: #4a5565;
        }
          .text-xs {
          font-size: 0.75rem;
        }
      `}</style>
    </div>
  ))}
</div>


  );
};

export default TopSummaryCards;
